"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEADER_PROPS = exports.HEADER_CLASS_NAME = exports.FOOTER_PROPS = exports.DEFAULT_LANGUAGES = exports.SOCIAL_NAMES = exports.SOCIAL_IMAGES = exports.DEFAULT_LOGO_ALT = exports.DEFAULT_LOGO = exports.TOGGLE_PARAM_VALUE = exports.TOGGLE_PARAM_NAME = exports.TOGGLE_STORAGE_VALUE = exports.TOGGLE_STORAGE_KEY = void 0;
var TOGGLE_STORAGE_KEY = 'MTN_HIDDEN';
exports.TOGGLE_STORAGE_KEY = TOGGLE_STORAGE_KEY;
var TOGGLE_STORAGE_VALUE = 'y';
exports.TOGGLE_STORAGE_VALUE = TOGGLE_STORAGE_VALUE;
var TOGGLE_PARAM_NAME = 'metanav';
exports.TOGGLE_PARAM_NAME = TOGGLE_PARAM_NAME;
var TOGGLE_PARAM_VALUE = 'off';
exports.TOGGLE_PARAM_VALUE = TOGGLE_PARAM_VALUE;
var DEFAULT_LOGO = 'https://cdn.antwerpen.be/core_branding_scss/4.2.2/assets/images/a-logo.svg';
exports.DEFAULT_LOGO = DEFAULT_LOGO;
var DEFAULT_LOGO_ALT = 'Officieel Logo Antwerpen.';
exports.DEFAULT_LOGO_ALT = DEFAULT_LOGO_ALT;
var SOCIAL_IMAGES = {
  facebook: 'facebook',
  twitter: 'twitter',
  instagram: 'instagram',
  linkedin: 'linkedin',
  youtube: 'youtube-play',
  snapchat: 'snapchat-ghost',
  googleplus: 'google-plus',
  newsletter: 'newspaper-o'
};
exports.SOCIAL_IMAGES = SOCIAL_IMAGES;
var SOCIAL_NAMES = {
  facebook: 'Facebook',
  twitter: 'Twitter',
  instagram: 'Instagram',
  linkedin: 'LinkedIn',
  youtube: 'Youtube',
  snapchat: 'Snapchat',
  googleplus: 'Google +',
  newsletter: 'Nieuwsbrief'
};
exports.SOCIAL_NAMES = SOCIAL_NAMES;
var DEFAULT_LANGUAGES = [{
  label: 'NL',
  value: 'nl',
  alt: 'Nederlands'
}, {
  label: 'FR',
  value: 'fr',
  alt: 'Français'
}, {
  label: 'DE',
  value: 'de',
  alt: 'Deutsch'
}, {
  label: 'EN',
  value: 'en',
  alt: 'English'
}];
exports.DEFAULT_LANGUAGES = DEFAULT_LANGUAGES;
var FOOTER_PROPS = ['className', 'config', 'configUrl', 'doormatBottomLinks', 'doormatBottomTitle', 'doormatCenter', 'doormatClassName', 'doormatLeft', 'doormatLinksRenderFunction', 'doormatRight', 'doormatStyle', 'doormatTopLabel', 'doormatTopLink', 'doormatTopTarget', 'doormatTopTitle', 'doormatTopTitleHidden', 'firstLink', 'firstLinkFunction', 'firstLinkLabel', 'firstLinkRenderFunction', 'footerClassName', 'footerStyle', 'linksRenderFunction', 'secondLink', 'secondLinkFunction', 'secondLinkLabel', 'secondLinkRenderFunction', 'style', 'text', 'thirdLink', 'thirdLinkFunction', 'thirdLinkLabel', 'fourthLink', 'fourthLinkFunction', 'fourthLinkLabel', 'webcomponent'];
exports.FOOTER_PROPS = FOOTER_PROPS;
var HEADER_CLASS_NAME = 'mtn-o-header';
exports.HEADER_CLASS_NAME = HEADER_CLASS_NAME;
var HEADER_PROPS = ['className', 'children', 'style', 'webcomponent', 'accessibilitySkipToLink', 'accessibilitySkipToLabel', 'languagesActive', 'languagesOptions', 'languagesChangeFunction', 'logosMainUrl', 'logosMainAlt', 'logosMainLink', 'logosSubUrl', 'logosSubLink', 'logosSubAlt', 'logosMainDouble', 'logosMainSmall', 'contactTitle', 'contactLabel', 'contactSections', 'contactSocial', 'profileUser', 'profileLabel', 'profileLoginLabel', 'profileLogoutLabel', 'profileToggleLabel', 'profileToggleChecked', 'profileToggleFunction', 'profileLoginAlt', 'profileLogoutAlt', 'logoutFunction', 'loginFunction', 'profileLinks', 'configUrl', 'linksRenderFunction', 'config', 'loading', 'overviewLink', 'overviewLabel', 'overviewAlt', 'searchFunction', 'searchQuery', 'searchAutocompleteFunction', 'searchPlaceholder', 'menuLabel', 'menuHide', 'menuLinksRenderFunction', 'menuContent', 'inlineSearchFunction', 'inlineSearchInfo', 'inlineSearchResults', 'inlineSearchLabel', 'inlineSearchPlaceholder', 'inlineSearchAllResultsText', 'inlineSearchAllResultsLink'];
exports.HEADER_PROPS = HEADER_PROPS;